import { render, staticRenderFns } from "./case-verified.vue?vue&type=template&id=4dd6c0df&scoped=true"
import script from "./case-verified.vue?vue&type=script&lang=ts"
export * from "./case-verified.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd6c0df",
  null
  
)

export default component.exports